module.exports = __webpack_public_path__ + "img/onestore_download.2e1b6171.png";